import axios from '@/axios.js'

export default { 
  fetchDataListItems ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/users/data')
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/users/update', {item})
        .then((response) => {
          commit('UPDATE_USERS', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
